import React, { Component, ReactNode } from "react";
import { classNames } from "primereact/utils";
import { Inbox, type LucideIcon } from "lucide-react";

/* ------------------------------------------------------------------ */
/*  EmptyState – no-data / no-results placeholder                     */
/* ------------------------------------------------------------------ */

interface EmptyStateProps {
    title?: string;
    description?: string;
    icon?: LucideIcon;
    /** Optional action button / link */
    action?: ReactNode;
    className?: string;
}

class EmptyState extends Component<EmptyStateProps> {
    render() {
        const {
            title = "No data found",
            description,
            icon: Icon = Inbox,
            action,
            className,
        } = this.props;

        return (
            <div className={classNames("flex flex-col items-center justify-center py-12 px-6 text-center", className)}>
                <div className="w-16 h-16 rounded-2xl bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center mb-5">
                    <Icon
                        size={28}
                        strokeWidth={1.5}
                        className="text-neutral-400 dark:text-neutral-500"
                    />
                </div>
                <h3 className="text-base font-semibold text-neutral-900 dark:text-neutral-100 mb-1.5">
                    {title}
                </h3>
                {description && (
                    <p className="text-sm text-neutral-500 dark:text-neutral-400 max-w-sm">
                        {description}
                    </p>
                )}
                {action && <div className="mt-5">{action}</div>}
            </div>
        );
    }
}

export default EmptyState;
